import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import unhandledRejection from 'unhandled-rejection';
import ApiClient from '@sherpasystems/apiclient';
import { auth, clear } from '~/actions/user';
import { get } from '~/actions/translations';
import { list } from '~/actions/locations';
import { list as listActions } from '~/actions/actions';
import { list as listArticles } from '~/actions/articles';
import Transition from 'react-transition-group/Transition';
import Spinner from '~/components/Spinner';
import ConfirmationDialog from '~/components/ConfirmationDialog';
import DialogMessage from '~/dialogs/Message';
import DialogArticle from '~/dialogs/Article';
import DialogArticleNew from '~/dialogs/ArticleNew';
import DialogArticleMove from '~/dialogs/ArticleMove';
import DialogLocation from '~/dialogs/Location';
import DialogLocationEdit from '~/dialogs/LocationEdit';
import DialogLocationNew from '~/dialogs/LocationNew';
import DialogAction from '~/dialogs/Action';
import DialogActionNew from '~/dialogs/ActionNew';
import DialogActionPick from '~/dialogs/ActionPick';
import DialogArticleLocationSet from '~/dialogs/ArticleLocationSet';
import DialogRawMaterial from '~/dialogs/RawMaterial';
import DialogRawMaterialPick from '~/dialogs/RawMaterialPick';
import DialogRawMaterialMove from '~/dialogs/RawMaterialMove';
import DialogRawMaterialVerify from '~/dialogs/RawMaterialVerify';
import DialogRecipe from '~/dialogs/Recipe';
import DialogRecipePick from '~/dialogs/RecipePick';
import DialogProduce from '~/dialogs/Produce';
import DialogCustomersNew from '~/dialogs/CustomersNew';
import DialogCustomersNewPick from '~/dialogs/CustomersNewPick';
import DialogContainer from '~/dialogs/Container';
import DialogContainerEdit from '~/dialogs/ContainerEdit';
import DialogContainerNew from '~/dialogs/ContainerNew';
import DialogTask from '~/dialogs/Task';
import DialogTaskNew from '~/dialogs/TaskNew';
import DialogUserPick from '~/dialogs/UserPick';
import DialogContainerPick from '~/dialogs/ContainerPick';
import DialogArticlePick from '~/dialogs/ArticlePick';
import DialogLocationPick from '~/dialogs/LocationPick';
import DialogTaskPick from '~/dialogs/TaskPick';
import DialogOrderPick from '~/dialogs/OrderPick';
import DialogWork from '~/dialogs/Work';
import DialogOrder from '~/dialogs/Order';
import DialogOrderNew from '~/dialogs/OrderNew';
import DialogOrderEdit from '~/dialogs/OrderEdit';
import DialogVerifyStock from '~/dialogs/VerifyStock';
import DialogBundle from '~/dialogs/Bundle';
import DialogBundleNew from '~/dialogs/BundleNew';
import DialogBundleEdit from '~/dialogs/BundleEdit';

import { Button, IconButton } from 'react-toolbox/lib/button';
import { Snackbar } from 'react-toolbox';
import _ from 'lodash';
import style from './style.scss';

const dialogs = {
  message: { component: DialogMessage },
  article: { component: DialogArticle },
  articleNew: { component: DialogArticleNew },
  articleMove: { component: DialogArticleMove },
  verifyStock: { component: DialogVerifyStock },
  location: { component: DialogLocation },
  locationEdit: { component: DialogLocationEdit },
  locationNew: { component: DialogLocationNew },
  action: { component: DialogAction },
  actionNew: { component: DialogActionNew },
  actionPick: { component: DialogActionPick },
  articleLocationSet: { component: DialogArticleLocationSet },
  rawMaterial: { component: DialogRawMaterial },
  rawMaterialPick: { component: DialogRawMaterialPick },
  rawMaterialMove: { component: DialogRawMaterialMove },
  rawMaterialVerify: { component: DialogRawMaterialVerify },
  recipe: { component: DialogRecipe },
  recipePick: { component: DialogRecipePick },
  produce: { component: DialogProduce },
  customersNew: { component: DialogCustomersNew },
  customersNewPick: { component: DialogCustomersNewPick },
  container: { component: DialogContainer },
  containerNew: { component: DialogContainerNew },
  containerEdit: { component: DialogContainerEdit },
  task: { component: DialogTask },
  taskNew: { component: DialogTaskNew },
  userPick: { component: DialogUserPick },
  containerPick: { component: DialogContainerPick },
  articlePick: { component: DialogArticlePick },
  locationPick: { component: DialogLocationPick },
  taskPick: { component: DialogTaskPick },
  orderPick: { component: DialogOrderPick },
  work: { component: DialogWork },
  order: { component: DialogOrder },
  orderNew: { component: DialogOrderNew },
  orderEdit: { component: DialogOrderEdit },
  bundle: { component: DialogBundle },
  bundleNew: { component: DialogBundleNew },
  bundleEdit: { component: DialogBundleEdit }
};

const menuItems = {
  '/': { prio: 1, title: 'Dashboard', icon: '', level: 10000 },
  '/orders': { prio: 2, title: 'Orders', icon: '', level: 1500 },
  /* '/products': { prio: 3, title: 'Products', icon: '', level: 1000 }, */
  '/kits': { prio: 4, title: 'Kits', icon: '', level: 1000 },
  '/distributor': { prio: 5, title: 'Distributor', icon: '', level: 10000 },
  '/articles': { prio: 6, title: 'Products', icon: '', level: 10 },
  '/locations': { prio: 7, title: 'Warehouse locations', icon: '', level: 10 },
  '/raw-materials': { prio: 8, title: 'Raw Materials', icon: '', level: 10 },
  '/production': { prio: 9, title: 'Production', icon: '', level: 10 },
  // '/order': { prio: 9, title: 'Orders (new)', icon: '', level: 10 },
  // '/containers': { prio: 10, title: 'In-/Outgoing stock', icon: '', level: 10 },
  // '/tasks': { prio: 11, title: 'Tasks', icon: '', level: 10 },
  // '/transactions': { prio: 12, title: 'Transactions', icon: '', level: 10 },
  '/dashboardconfig': {
    prio: 13,
    title: 'Dashboard config',
    icon: '',
    level: 10
  },
  '/admin': { prio: 14, title: 'Admin', icon: '', level: 10 },
  '/logs': { prio: 15, title: 'Logs', icon: '', level: 10 },
  '/settings': { prio: 100, title: 'Settings', icon: '', level: 2000 }
};


const menu = [
  { label: 'Tools', uri: '/tools', },
  { label: 'Articles', uri: '/articles', },
  { label: 'Bundles', uri: '/bundles', },
  { label: 'Customers', uri: '/customersNew', },
  { label: 'Raw Materials', uri: '/raw-materials', },
  { label: 'Orders', uri: '/order', },
  { label: 'Containers', uri: '/containers', },
  { label: 'Production', uri: '/production', },
  { label: 'Work', uri: '/work', },
  { label: 'Warehouse locations', uri: '/locations', },
  { label: 'Actions', uri: '/actions', },
  { label: 'Transactions', uri: '/transactions', },
];

class AppFrame extends React.Component {
  static childContextTypes = {
    apiClient: React.PropTypes.object,
    showMessage: React.PropTypes.func,
    dialogPush: React.PropTypes.func,
    dialogPop: React.PropTypes.func,
    dialogClose: React.PropTypes.func
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    const apiURI = localStorage.API_URI || CONFIG.api_url;
    console.log(`connect against API at ${apiURI}`);
    this.apiClient = new ApiClient({
      uri: apiURI,
      session: props.session
    });
    this.apiClient.setCastHandler(payload => {
      this.gotCast(payload);
    });
    this.state = {
      loading: true,
      loginEmail: '',
      loginSecret: '',
      error: '',
      showMobile: false,
      dialogs: {},
      dialogId: 0,
      dialogStack: []
    };
  }

  getChildContext() {
    return {
      apiClient: this.apiClient,
      showMessage: this.showMessage.bind(this),
      dialogPush: this.dialogPush.bind(this),
      dialogPop: this.dialogPop.bind(this),
      dialogClose: this.dialogClose.bind(this)
    };
  }

  componentDidMount() {
    this.context.router.history.listen(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
    const rejectionEmitter = unhandledRejection({
      timeout: 20
    });
    rejectionEmitter.on('unhandledRejection', error => {
      if (typeof error === 'object' && error.status && error.error) {
        return this.showMessage(
          'There was a problem',
          `Code: ${error.status}\n\nMessage: ${error.error}`
        );
      }
      throw error;
    });
    const promises = [];
    promises.push(get(this.props.dispatch, this.props.language)); // Get translation file
    if (this.props.session) {
      // Auth if we have a session cookie
      promises.push(
        auth(this.props.dispatch, this.apiClient, {
          session: this.props.session
        })
          .then(() =>
            Promise.all([
              list(this.props.dispatch, this.apiClient),
              listActions(this.props.dispatch, this.apiClient),
              listArticles(this.props.dispatch, this.apiClient),
            ])
          )
          .catch(() => clear(this.props.dispatch)) // Clear session if login fails
      );
    }
    Promise.all(promises) // Wait for all async loading then let the application start
      .then(() => this.setState({ loading: false }));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.language !== nextProps.language) {
      // language has changed
      this.setState({ loading: true });
      get(this.props.dispatch, nextProps.language).then(() =>
        this.setState({ loading: false })
      );
    }
  }

  gotCast(payload) {
    switch (payload.type) {
      case 'orderUpdate':
        this.props.dispatch({ type: 'ORDER_UPDATE', data: payload.data });
        break;
      case 'dashboardCmd':
        this.props.dispatch({ type: 'DASHBOARD_CMD', data: payload.data });
        break;
      case 'heartbeat':
        this.props.dispatch({ type: 'HEARTBEAT', data: payload.data });
        console.log('got heartbeat');
        break;
      default:
        console.log('Unahandled cast', payload);
    }
  }

  hideSnackBar() {
    this.props.dispatch({ type: 'SNACKBAR_HIDE' });
  }

  hideConfirmation() {
    this.props.dispatch({ type: 'CONFIRMATION_HIDE' });
  }

  navigate(url) {
    return this.context.router.history.push(url);
  }

  dialogPush(type, data) {
    const id = `dialog_${this.state.dialogId}`;
    this.setState({
      dialogs: {
        ...this.state.dialogs,
        [id]: {
          type,
          data: typeof data === 'object' ? data : {}
        }
      },
      dialogStack: [...this.state.dialogStack, id],
      dialogId: this.state.dialogId + 1
    });
    return id;
  }

  dialogClose(id) {
    this.setState({
      dialogStack: this.state.dialogStack.filter(i => i !== id)
    });
    setTimeout(() => this.dialogCleanup(id), 1000);
  }

  dialogPop() {
    const id = this.state.dialogStack[this.state.dialogStack.length - 1];
    this.dialogClose(id);
  }

  dialogCleanup(id) {
    const newState = { ...this.state.dialogs };
    delete newState[id];
    this.setState({ dialogs: newState });
  }

  showMessage(content = '', subContent = '') {
    /* this.setState({
      messageActive: title || message,
      messageContent: typeof title !== 'boolean' ? title : this.state.messageContent,
      messageSubContent: typeof message !== 'boolean' ? message : this.state.messageSubContent
    });*/
    this.dialogPush('message', { content, subContent });
  }

  logout() {
    this.navigate('/');
    clear(this.props.dispatch);
  }

  isCurrentRoute(route) {
    const routes = this.context.router.route.location.pathname.split('/');
    if (routes.length < 2) return false;
    if (`/${routes[1]}` === route) return true;
    return false;
  }

  showMobileMenu() {
    this.setState({ showMobile: true });
  }

  navigateMobile(item) {
    this.setState({ showMobile: false });
    this.context.router.history.push(item);
  }

  renderLogin() {
    if (this.state.loading) {
      // language file has not been loaded yet
      return (
        <div className={style.login}>
          <Spinner className={style.spinner} />
        </div>
      );
    }
    return <div className={style.login}>{this.props.children}</div>;
  }

  renderError() {
    if (this.state.error) {
      return <div className={style.error}>{this.state.error}</div>;
    }
    return false;
  }

  renderApp() {
    const { showMobile } = this.state;
    const user = this.props.user && this.props.user.toJS();
    return (
      <div>
        <div className={style.menu}>
          <div className={style.navigation}>
            {Object.keys(menuItems)
              .sort((a, b) => {
                if (menuItems[a].prio < menuItems[b].prio) return -1;
                if (menuItems[b].prio < menuItems[a].prio) return 1;
                return 0;
              })
              .map(item => {
                if (menuItems[item].level >= user.level) {
                  return (
                    <div
                      key={`desktop_${menuItems[item].prio}`}
                      className={[
                        style.item,
                        this.isCurrentRoute(item) && style.active
                      ].join(' ')}
                      onClick={() => this.context.router.history.push(item)}
                    >
                      {menuItems[item].title}
                    </div>
                  );
                }
                return false;
              })}
            {user.level <= 10 && <div>
              {menu.length > 0 && <div className={style.menuHeader}>New system</div>}
              {menu.map((item, i) => <div
                key={i}
                className={style.menuItem}
                onClick={() => this.navigate(item.uri)}
              >
                {item.label}
              </div>)}
            </div>}
          </div>

          <Button
            className={style.logOut}
            onClick={() => this.logout()}
            accent
            raised
            label="Log out"
            icon="open_in_browser"
          />
        </div>
        <IconButton
          className={style.showMobile}
          onClick={() => this.showMobileMenu()}
          accent
          icon="dehaze"
        />
        {showMobile && (
          <div className={style.menuMobile}>
            <div className={style.navigation}>
              {Object.keys(menuItems)
                .sort((a, b) => {
                  if (menuItems[a].prio < menuItems[b].prio) return -1;
                  if (menuItems[b].prio < menuItems[a].prio) return 1;
                  return 0;
                })
                .map(item => {
                  if (menuItems[item].level >= user.level) {
                    return (
                      <div
                        key={`mobile_${menuItems[item].prio}`}
                        className={[
                          style.item,
                          this.isCurrentRoute(item) && style.active
                        ].join(' ')}
                        onClick={() => this.navigateMobile(item)}
                      >
                        {menuItems[item].title}
                      </div>
                    );
                  }
                  return false;
                })}
              {menu.length > 0 && <div className={style.menuHeader}>New system</div>}
              {menu.map((item, i) => <div
                key={i}
                className={style.menuItem}
                onClick={() => this.navigateMobile(item.uri)}
              >
                {item.label}
              </div>)}
            </div>

            <Button
              className={style.logOut}
              onClick={() => this.logout()}
              accent
              raised
              label="Log out"
              icon="open_in_browser"
            />
          </div>
        )}
        <div className={style.content}>
          {this.props.children}
          <div className="buildInformation">
            UI: {CONFIG.version}
            <br />API: {user.apiVersion}
          </div>
        </div>
        <Snackbar
          action="Dismiss"
          active={this.props.showSnackbar}
          label={this.props.snackbarMsg}
          timeout={4000}
          onClick={() => this.hideSnackBar()}
          onTimeout={() => this.hideSnackBar()}
          type={this.props.snackType}
        />
        <ConfirmationDialog
          active={this.props.confirmation.get('active')}
          onCancelClick={() => this.hideConfirmation()}
          onOkClick={() => {
            this.hideConfirmation();
            const func = this.props.confirmation.get('onOk');
            return typeof func === 'function' && func();
          }}
        >
          <div>{this.props.confirmation.get('msg')}</div>
        </ConfirmationDialog>
      </div>
    );
  }

  render() {
    // Disable body scrolling when there are overlays active;
    document.body.style.overflow =
      this.state.modal || this.state.menuOpen ? 'hidden' : 'auto';
    const user = this.props.user && this.props.user.toJS();

    const pathname = _.get(
      this.context,
      ['router', 'history', 'location', 'pathname'],
      '/'
    );
    if (pathname === '/dashboardinit') {
      return <div> {this.props.children} </div>;
    }
    return (
      <div className={style.container}>
        {Object.keys(this.state.dialogs).map(id => (
          <Transition
            key={id}
            in={this.state.dialogStack.includes(id)}
            timeout={200}
            mountOnEnter
            unmountOnExit
          >
            {transition => {
              const Dialog = dialogs[this.state.dialogs[id].type].component;
              return (
                <Dialog
                  transition={transition}
                  dialogId={id}
                  data={this.state.dialogs[id].data}
                />
              );
            }}
          </Transition>
        ))}
        {user && this.renderApp()}
        {!user && this.renderLogin()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.getIn(['cookie', 'language'], 'en'),
  session: state.getIn(['cookie', 'access_session'], false),
  user: state.getIn(['user', 'self'], false),
  pending: state.getIn(['user', 'pending'], true),
  showSnackbar: state.getIn(['snackbar', 'active'], true),
  snackbarMsg: state.getIn(['snackbar', 'msg'], ''),
  snackType: state.getIn(['snackbar', 'type'], 'accept'),
  confirmation: state.getIn(['confirmation'], {})
});

// Setting pure: false is required for react router to work
export default withRouter(connect(mapStateToProps)(AppFrame));



// WEBPACK FOOTER //
// ./app/components/AppFrame/index.js